import { Blocks } from '@tymbe/schema/company-blocked-user.interface';
import { PerkData } from '@tymbe/schema/perk.interface';
import { PersonData } from '@tymbe/schema/person.interface';

export type OwnProps = {
  companyId?: number;
  branchOfficeId?: number;
  departmentId?: number;
  onlyInvitable?: { shiftId: number }
  filter?: { role: string },
  exclude?: { personIds: number[] },
  limitToRelatedCompanies?: boolean,
  shiftPerks?: PerkData[]
};

export enum PersonCategory {
  Newbie,
  BestRated,
  MostAttendancesInMonth,
  MostAttendancesInYear,
  Others,
  Blocked,
}

export type TySelectInvitationQueryConfig = {
  companyId?: number;
  branchOfficeId?: number,
  onlyInvitable?: { shiftId: number },
  filter?: { role: string },
  exclude?: { personIds: number[] },
  limitToRelatedCompanies?: boolean,
  shiftPerks?: PerkData[]
};

export type TySelectInvitationOptionData = PersonData & { category: PersonCategory, blocks: Blocks };
